var React = require('react');

function Minus16x16 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Color=Black, State=Minus, Size=16x16"},React.createElement("path",{"id":"Vector","d":"M15 8H1","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"})));
}

Minus16x16.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Minus16x16;

Minus16x16.default = Minus16x16;
